module.exports = __webpack_public_path__ + "static/media/home_img.1d83a7ba.svg";